import type { InternalRequestDetailResponse } from "@synthesis/shared-services/internal/application/types";
import { Tag } from "@synthesis/shared-ui";

import type { ApplicationStatus } from "../../constants";
import {
  APPLICATION_STATUS_FALLBACK_LABEL,
  type ApplicationProcessingState,
  APPLICATION_PROCESSING_STATE_APPEARANCE,
  type ApplicationStatusContour,
  getApplicationStatusAppearance,
  INTERNAL_APPLICATION_STATUS_FALLBACK_LABEL,
} from "../application-status-ui";

const STATUS_ICON_CLASS = "size-5 shrink-0";

type ApplicationStatusBadgeProps = {
  status: ApplicationStatus;
  label?: string | null;
  contour?: ApplicationStatusContour;
};

export const ApplicationStatusBadge = ({ status, label, contour = "internal" }: ApplicationStatusBadgeProps) => {
  const appearance = getApplicationStatusAppearance(status, contour);
  const Icon = appearance.icon;

  return (
    <span className="inline-flex items-center">
      <Tag className={appearance.className} leftIcon={<Icon aria-hidden className={STATUS_ICON_CLASS} />} size="status">
        {label ?? APPLICATION_STATUS_FALLBACK_LABEL[status]}
      </Tag>
    </span>
  );
};

type ApplicationProcessingStateBadgeProps = {
  processingState: ApplicationProcessingState;
  label: string;
};

export const ApplicationProcessingStateBadge = ({ processingState, label }: ApplicationProcessingStateBadgeProps) => {
  const appearance = APPLICATION_PROCESSING_STATE_APPEARANCE[processingState];
  const Icon = appearance.icon;

  return (
    <span className="inline-flex items-center">
      <Tag className={appearance.className} leftIcon={<Icon aria-hidden className={STATUS_ICON_CLASS} />} size="status">
        {label}
      </Tag>
    </span>
  );
};

export const InternalApplicationStatus = (item: InternalRequestDetailResponse) => {
  const applicationStatus = item.status;

  if (!applicationStatus) {
    return <span className="text-type-minor">—</span>;
  }

  return (
    <ApplicationStatusBadge
      contour="internal"
      label={item.displayStatus ?? INTERNAL_APPLICATION_STATUS_FALLBACK_LABEL[applicationStatus]}
      status={applicationStatus}
    />
  );
};
